

































































import { checklistPostReq } from "@/services/checklist.service";
import { de } from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      date: new Date().toISOString().substr(0, 7),
      menu: false,
      modal: false,
      initLoaded: false,
      list: [],
      search: null,

      headers: [
        { text: "Gebucht", value: "created_at", sortable: true },
        { text: "Benutzername", value: "name", sortable: true },
        { text: "Datum", value: "date", sortable: true },
        { text: "Inspektor", value: "inspector", sortable: true },
        { text: "Umfang", value: "scope", sortable: true },
        { text: "Type", value: "type", sortable: true },
        { text: "Projekt", value: "projectNumber", sortable: true },
        { text: "Anlage", value: "site", sortable: true },
        { text: "Seriennummer", value: "machine", sortable: true },
      ],
    };
  },
  mounted() {
    this.$store.state.headerTitle = this.$t("NAVI.BOOKING"); //"Gebuchte Inspektionen"

    checklistPostReq("billing-list", {})
      .then((resp) => {
        if (resp.data && resp.data.list) {
          this.list = resp.data.list;
        }

        this.initLoaded = true;
      })
      .catch((e) => {
        this.$store.dispatch("api_error", e);
      });
  },
  methods: {

    customFormatter(date) {
      return moment(date).format("MMMM YYYY");
    },
    deleteRow(item) {
      checklistPostReq("finalize-pwd-remove", { item: item })
        .then((resp) => {
          if (resp.data && resp.data.list) {
            this.list = resp.data.list;
          }
        })
        .catch((e) => {
          this.$store.dispatch("api_error", e);
        });
    },

    exportXls() {
      checklistPostReq("export-bookings", { date: this.date })
        .then((resp) => {
          console.log("resp", resp)


            var csvData = new Blob(["\uFEFF" + resp.data.csv], {
              type: "text/csv;charset=windows-1252",
            });
            var csvURL = null;
            if (navigator.msSaveBlob) {
              csvURL = navigator.msSaveBlob(csvData, "download.csv");
            } else {
              csvURL = window.URL.createObjectURL(csvData);
            }
            var tempLink = document.createElement("a");
            tempLink.href = csvURL;
            tempLink.setAttribute(
              "download",
              new Date().getFullYear() +
                "_" +
                (new Date().getMonth() + 1) +
                "_" +
                new Date().getDate() +
                "_purchases.csv"
            );
            tempLink.click();
        


        })
        .catch((e) => {
          this.$store.dispatch("api_error", e);
        });
    },
  },
};
